import React, { SVGProps } from 'react'
import withIcon from './hoc/withIcon'

const Save: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.59961 10.0006C8.59961 9.50353 9.00255 9.10059 9.49961 9.10059H14.4996C14.9967 9.10059 15.3996 9.50353 15.3996 10.0006C15.3996 10.4976 14.9967 10.9006 14.4996 10.9006H9.49961C9.00255 10.9006 8.59961 10.4976 8.59961 10.0006Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9996 20.9006C20.049 20.9006 20.8996 20.0499 20.8996 19.0006V8.40602C20.8996 6.99893 20.3406 5.64947 19.3457 4.65451C18.3507 3.65955 17.0013 3.10059 15.5942 3.10059H4.99961C3.95027 3.10059 3.09961 3.95124 3.09961 5.00059V19.0006C3.09961 20.0499 3.95027 20.9006 4.99961 20.9006H18.9996ZM4.99961 4.90059C4.94438 4.90059 4.89961 4.94536 4.89961 5.00059V19.0006C4.89961 19.0558 4.94438 19.1006 4.99961 19.1006H7.09961V15.0006C7.09961 13.9512 7.95027 13.1006 8.99961 13.1006H14.9996C16.049 13.1006 16.8996 13.9512 16.8996 15.0006V19.1006H18.9996C19.0548 19.1006 19.0996 19.0558 19.0996 19.0006V8.40602C19.0996 7.47632 18.7303 6.5847 18.0729 5.9273C17.4155 5.26991 16.5239 4.90059 15.5942 4.90059H4.99961ZM15.0996 19.1006V15.0006C15.0996 14.9454 15.0548 14.9006 14.9996 14.9006H8.99961C8.94438 14.9006 8.89961 14.9454 8.89961 15.0006V19.1006H15.0996Z"
      />
    </svg>
  )
}

Save.displayName = 'Save'

export default withIcon(Save)
